import { render, staticRenderFns } from "./Puton.vue?vue&type=template&id=f546dd8c&scoped=true&"
import script from "./Puton.vue?vue&type=script&lang=js&"
export * from "./Puton.vue?vue&type=script&lang=js&"
import style0 from "./Puton.vue?vue&type=style&index=0&id=f546dd8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f546dd8c",
  null
  
)

export default component.exports